<template>
  <div class="rattachements__top">
    <BasicText
      size="body-m"
      color="secondary-900"
    >
      Retrouvez ci-dessous l’ensemble des comptes auxquels vous êtes rattaché.
    </BasicText>
    <BasicButton
      icon-name="profile"
      label="Demander un rattachement"
      @click="demanderRattachement"
      class="rattachements__top--demande"
    />
  </div>
  <HabilitationsAdmin
    v-if="token"
    type="utilisateur"
    :auto-run="autoRun"
    :jwt-token="token"
    :context="contextApp"
    :context-hidden="true"
  ></HabilitationsAdmin>
  <Teleport to="#app">
    <HabilitationsAdd />
  </Teleport>
</template>

<script setup lang="ts">
  import { computed, onBeforeMount, onBeforeUnmount, ref } from 'vue'
  import { storeToRefs } from 'pinia'
  import HabilitationsAdmin from '@/features/interface/profil-utilisateur/sections/admin/HabilitationsAdmin.vue'
  import { useHabilitationsAdminViewStore } from '@/features/interface/profil-utilisateur/sections/admin/useHabilitationsAdminViewStore.ts'
  import { useAppStateStore } from '@/features/application'
  import { typeContextCourantToContextAppType, TypesContextesAutorisesEnum } from '@/features/auth/context-app'
  import HabilitationsAdd from '@/features/interface/profil-utilisateur/sections/admin/HabilitationsAdd.vue'
  import { useDemandeRattachement } from '@/features/interface/profil-utilisateur/sections/rattachements/demande'

  const authStore = useHabilitationsAdminViewStore()
  const appContext = useAppStateStore()
  const { contextCourant } = storeToRefs(appContext)
  const autoRun = ref(false)

  const { token } = storeToRefs(authStore)
  const contextApp = computed(() => {
    const existContext = [TypesContextesAutorisesEnum.Adherent, TypesContextesAutorisesEnum.Prestataire].includes(
      contextCourant.value,
    )
    if (existContext) return typeContextCourantToContextAppType(contextCourant.value)
    return undefined
  })

  async function demanderRattachement() {
    const rattachementManager = useDemandeRattachement()
    await rattachementManager.showDialog()
  }

  onBeforeMount(async () => {
    autoRun.value = true
    await authStore.start()
  })

  onBeforeUnmount(() => {
    authStore.stop()
  })
</script>
<style lang="less">
.dark {
  .card {
    &__top {
      &__text {
        span {
          color: white;
        }
      }
    }
  }
}
  .rattachements__top {
    margin-top: 20px;
    justify-content: space-between;
    display: flex;
    flex-wrap: nowrap;
    gap: @spacing-20;
    &--choix {
      width: 400px;
    }
  }

  @container (max-width: @breakpoint-mobile) {
    .rattachements__top {
      margin-bottom: 0;
      flex-direction: column;
      &--choix {
        flex: 1;
        width: 100%;
      }
    }
  }
</style>
